export default __webpack_public_path__ + "static/media/properties1.266c4363.jpg";